/* eslint-disable react/no-array-index-key */
import React from 'react';

import { useContent } from './hooks';
import Text from './Text';
import List from './List';
import { Title, Introduction, SubTitle } from './styles';

const About = () => {
  const { title, description, management, partner } = useContent();

  return (
    <>
      <Title>{title}</Title>
      <Introduction>
        {description.map((item, key) => (
          <Text key={key}>{item}</Text>
        ))}
      </Introduction>
      <SubTitle>{management.title}</SubTitle>
      <List>{management.items}</List>
      <SubTitle>{partner.title}</SubTitle>
      <List>{partner.items}</List>
    </>
  );
};

export default About;
